<mat-form-field appearance="fill" class="calao-date-range-picker">
	<mat-date-range-input [rangePicker]="picker">
		<input matStartDate #dateRangeStart placeholder="Début">
		<input matEndDate #dateRangeEnd placeholder="Fin" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">>
	</mat-date-range-input>
	<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
	<mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>